// extracted by mini-css-extract-plugin
export default {"result":"SearchResult_result__K9VD7"};